import React from 'react'
import appconstants from '../../themes/appconstant'
import images from '../../themes/appImage'
import { useNavigate } from 'react-router-dom'
import ButtonLayout from "../../common/layoutButton";


const Linkfailed = () => {
  const navigate = useNavigate();
  const handelClick = () => {
    navigate("/login");
  }
  return (
    <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between  ">
      <div className='max-w-[424px] max-h-[455px]  flex items-center flex-col mt-5  px-3  '>
        <img className=" mb-5 " src={images.appLogo} alt="metafit-logo" />
        <div className='w-full bg-white border shadow-metafit-shadow rounded-lg p-6 md:p-2 sm:w-[100vw] '>
          <div className='flex flex-col gap-4 items-center justify-center mt-3 mb-3'>

            <div className='text-2xl font-semibold text-dark text-center mt-8 mb-1'>Your reset password link has been expired.</div>
            <ButtonLayout text="Click to login" onClick={handelClick} />


          </div>
          <div>
          </div>


        </div>
      </div>
      <div className=" text-sm text-light mb-3 ">{appconstants.metafitRights}</div>
    </div>
  )
}

export default Linkfailed;